<template>
  <div>
    <cv-radio-group class="small-details-logo-options" :vertical="true">
      <span class="font-14 bold">
        {{ $t('wizard-v2.small-details.what-would-you-like-to-do') }}</span
      >
      <small-details-option-box
        :title="$t('wizard-v2.small-details.logo-options.option-1')"
        :description="
          $t('wizard-v2.small-details.logo-options.option-1-description')
        "
        :selected="selectedOption === CONTINUE_WITH_CURRENT_LOGO"
        @clicked="() => $emit('option-selected', CONTINUE_WITH_CURRENT_LOGO)"
      />
      <small-details-option-box
        v-if="isLogoImprovementVisible"
        :title="$t('wizard-v2.small-details.logo-options.option-2')"
        :description="
          $t('wizard-v2.small-details.logo-options.option-2-description')
        "
        :selected="selectedOption === REQUEST_LOGO_IMPROVEMENTS"
        :is-request-logo-improvements="true"
        @clicked="() => $emit('option-selected', REQUEST_LOGO_IMPROVEMENTS)"
      />

      <logo-improvement-form
        v-if="selectedOption === REQUEST_LOGO_IMPROVEMENTS"
        :file-name="fileName"
        :logo-improvement-form-data="logoImprovementFormData"
        @update-form="(form) => $emit('update-form', form)"
      />
      <small-details-option-box
        :title="$t('wizard-v2.small-details.logo-options.option-3')"
        :description="
          $t('wizard-v2.small-details.logo-options.option-3-description')
        "
        :selected="selectedOption === SELECT_REVISED_LOGO"
        @clicked="() => $emit('option-selected', SELECT_REVISED_LOGO)"
      />
    </cv-radio-group>
  </div>
</template>

<script>
import { CvRadioGroup } from '@carbon/vue';
import SmallDetailsOptionBox from './SmallDetailsOptionBox.vue';
import {
  CONTINUE_WITH_CURRENT_LOGO,
  REQUEST_LOGO_IMPROVEMENTS,
  SELECT_REVISED_LOGO,
} from '@/constants/smallDetails';
import LogoImprovementForm from '../LogoImprovementFom/LogoImprovementForm.vue';

export default {
  components: {
    CvRadioGroup,
    SmallDetailsOptionBox,
    LogoImprovementForm,
  },
  props: {
    selectedOption: {
      type: String,
      default: '',
    },
    fileName: {
      type: String,
      default: '',
    },
    logoImprovementFormData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    isLogoImprovementVisible: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      CONTINUE_WITH_CURRENT_LOGO,
      REQUEST_LOGO_IMPROVEMENTS,
      SELECT_REVISED_LOGO,
    };
  },
};
</script>

<style lang="scss">
.small-details-logo-options {
  width: 100%;
}

.bx--radio-button-group--vertical {
  width: 100%;
  padding: 0 15px;
  margin-bottom: 10px;
}
</style>
